import { render, staticRenderFns } from "./ResultsBreakdownLayout.vue?vue&type=template&id=35e6f11c"
import script from "./ResultsBreakdownLayout.vue?vue&type=script&lang=js"
export * from "./ResultsBreakdownLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports